import React, {Component} from 'react'
import {connect} from 'react-redux'
import '../assets/App.css'
import {
    Row,
    Col,
    Grid,
    Panel,
    Button,
    PanelBody,
    PanelContainer,
    FormControl,
    InputGroup,
    Icon,
} from '@sketchpixy/rubix'
import packageJson from "../../package.json"

class SplashPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            authenticate: !!this.props.loginToken,
            password: "",
            repassword: "",
            rePassBorder: "",
            param: this.props && this.props.match && this.props.match.params && this.props.match.params.setPasswordToken,
            showAccountExistsMessage: false
        }
        this.goToLogin = this.goToLogin.bind(this)
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(newProps) {
        if (newProps.loginToken) {
            this.setState({authenticate: true})
        }
    }

    actions = link => {
        const {history} = this.props
        history.push(link)
    }
    onChangeValue = (e, field) => {
        let {password, repassword, rePassBorder} = this.state
        if (field === "password") {
            password = e.target.value
        } else if (field === "repassword") {
            repassword = e.target.value
        }
        this.setState({password, repassword})
    }

    goToLogin = () => {
        window.location = "/login"
    }

    addNewUser = () => {
        let {password, repassword, param} = this.state
        if(password === "" || repassword === "") {
            alert("Password and re-password cannot be empty")
        } else {
            if (password === repassword) {

                let body = {forgotToken: param, password: password}
                
            let headers = {'Content-Type': 'application/json'};
            let url = process.env.API_URL+"/users/register"
        
            fetch(url, {method: "POST", body: JSON.stringify(body), headers} )
            .then(response => response.json())
            .then(data => {
                if(data.token !== undefined) {
                    localStorage.setItem("login_token", data.token)
                    localStorage.setItem("role", data.role)
                    window.location = data.companyName;
                } else {
                    this.setState({showAccountExistsMessage: true})
                }
            })
            .catch(err => {
                console.error(err)
                });
            } else {
                alert("Password does not match with Re Password")
            }
        }
    }
    render() {

        let {password, repassword, rePassBorder, param} = this.state
        // let {from} = this.props.location.state || {from: '/admin/dashboard'}

        
        return (
            <div id='auth-container' className='login'>
                <div id='#auth-row-0'>
                    <div id='auth-cell'>
                        <Grid>
                            <Row>
                                <Col className="bg-white  app-logo" smOffset={0} xsOffset={0} collapseLeft collapseRight>
                                    <a href="/" style={{paddingLeft: '15px'}}>
                                        <img style={{top: '-12px', margin: '0'}} src="/imgs/app/vbgTextIcon.svg" width="180"
                                            alt="" height="70"/>
                                    </a>
                                </Col>
                                
                            </Row>
                            
                            <Row>
                                <Row className="bg-custom-colot-blue" style={{marginLeft: "40px", marginRight: "40px", borderRadius: "10px", marginTop: "10px"}}>
                                    
                                    <Col smOffset={3} md={6}  collapseLeft collapseRight >
                                    <PanelContainer controls={false}>
                                        <Panel className="bg-custom-colot-blue">
                                            <PanelBody style={{padding: 0}}>
                                                
                                                <div className='text-center fg-darkblue'>
                                                    <h1 className='heading-main' >Reset Your Password</h1>
                                                </div>
                                                <div className="">
                                                        <div style={{
                                                        padding: 25,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        margin: 'auto',
                                                        marginBottom: 25,
                                                        marginTop: 25
                                                    }}>
                                                        </div>
                                                        <div style={{margin: "0 auto", marginLeft: "40px", marginRight: "40px"}}>
                                                        <InputGroup style={{width: "100%"}} bsSize='large'>
                                                            <label className="form-label">Enter a new password </label>
                                                            <FormControl autoFocus type='password'
                                                                            className='border-focus-blue required border-blue input1'
                                                                            name='password'
                                                                            onChange={e => this.onChangeValue(e, "password")}
                                                                            value={password}/>
                                                        </InputGroup>
                                                        <br />
                                                        <InputGroup style={{width: "100%"}} bsSize='large'>
                                                            <label className="form-label">Confirm new password </label>
                                                            <FormControl autoFocus type='password'
                                                                            className='border-focus-blue required border-blue input1'
                                                                            name='password'
                                                                            onChange={e => this.onChangeValue(e, "repassword")}
                                                                            style={rePassBorder? {borderColor: "red"}: {}}
                                                                            value={repassword}/>
                                                        </InputGroup>
                                                        </div>
                                                </div><br /><br/>
                                                <div style={{margin: "0 auto", marginLeft: "40px", marginRight: "40px"}} className="row">
                                                    <div style={{textAlign: "center"}} >
                                                    <Button
                                                        style={{width: "100%"}}
                                                        type='button'
                                                        name={"addNew"}
                                                        bsStyle='primary'
                                                        onClick={this.addNewUser}
                                                        className="list-btn btn-lg reset-text-transform"
                                                    >Reset Password</Button>
                                                    </div>
                                                </div>  

                                                <br />

                                                {                                       
                                                    this.state.showAccountExistsMessage &&
                                                    <p style={{textAlign: "center", color: "green", fontSize: "1.7rem", fontWeight: "bold"}}>We believe you have completed this step, <span style={{cursor: "pointer", textDecorationLine: "underline", color: "blue"}} onClick={this.goToLogin}>click here to login</span></p>
                                                }
                                            </PanelBody>
                                        </Panel>
                                    </PanelContainer>
                                    </Col>
                                </Row>
                            </Row>
                            <Row style={{width: "100%", textAlign: "center", paddingBottom: "0.5rem", marginTop: "10px"}} className="">
                                <Col collapseLeft collapseRight>
                                    <span>&copy; 2023 Veteran Benefits Guide<br/>App version: {packageJson.version}</span>
                                </Col>
                            </Row>
                            <Row className="text-bottom-splash">
                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }
}

const
    mapStateToProps = ({login}) => {
        const {loginToken} = login
        return {loginToken}
    }

const
    mapDispatchToProps = dispatch => ({
        
    })

export default connect(mapStateToProps, mapDispatchToProps)(SplashPage)
